import { render, staticRenderFns } from "./questionbankList.vue?vue&type=template&id=a50cf272&scoped=true&"
import script from "./questionbankList.vue?vue&type=script&lang=js&"
export * from "./questionbankList.vue?vue&type=script&lang=js&"
import style0 from "./questionbankList.vue?vue&type=style&index=0&id=a50cf272&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a50cf272",
  null
  
)

export default component.exports